(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-spotlight-tabs"] && !Shopify.designMode) return;
  try {
    
  class BcSpotlightTabs extends HTMLElement {
    #abortController = null;
    #observers = [];

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      for (const tab of this.tabs) {
        tab.addEventListener('click', this.#handleTabClick.bind(this), { signal });
        tab.addEventListener('keydown', this.#handleTabKeydown.bind(this), { signal });
      }

      this.#setupScrollButtons(signal);
      this.#setupHeadingFit();

      // Subscribe & Save toggle -> selling plan input
      this.addEventListener(
        'change',
        (event) => {
          const toggle = event.target.closest('[data-bc-sub-toggle]');
          if (!toggle) return;
          const form = toggle.closest('form');
          const planInput = form?.querySelector('[data-bc-selling-plan]');
          if (planInput) planInput.value = toggle.checked ? toggle.dataset.planId : '';
        },
        { signal }
      );

      // Optional AJAX add to cart
      this.addEventListener(
        'submit',
        async (event) => {
          const form = event.target.closest('form[data-bc-ajax]');
          if (!form) return;
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const label = form.querySelector('[data-bc-button-label]');
          const original = label ? label.textContent : '';
          if (button) button.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: new FormData(form),
            });
            if (!response.ok) throw new Error('Add to cart failed');
            if (label) label.textContent = '✓ Added';
            document.dispatchEvent(new CustomEvent('bc:cart:added', { bubbles: true }));
          } catch (error) {
            if (label) label.textContent = 'Try again';
          } finally {
            if (button) button.disabled = false;
            if (label) setTimeout(() => (label.textContent = original), 2000);
          }
        },
        { signal }
      );

      if (window.Shopify?.designMode) {
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const panel = this.panels.find(
              (p) => p === event.target || p.contains(event.target)
            );
            if (!panel) return;
            const tab = this.tabs.find(
              (t) => t.getAttribute('aria-controls') === panel.id
            );
            if (tab) this.#activateTab(tab);
          },
          { signal }
        );
      }
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      for (const observer of this.#observers) observer.disconnect();
      this.#observers = [];
    }

    #handleTabClick(event) {
      this.#activateTab(event.currentTarget);
    }

    #handleTabKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let newIndex = null;

      if (event.key === 'ArrowRight') newIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') newIndex = 0;
      if (event.key === 'End') newIndex = this.tabs.length - 1;

      if (newIndex === null) return;

      event.preventDefault();
      const nextTab = this.tabs[newIndex];
      this.#activateTab(nextTab);
      nextTab.focus();
    }

    #activateTab(tab) {
      const panelId = tab.getAttribute('aria-controls');

      for (const t of this.tabs) {
        const isActive = t === tab;
        t.setAttribute('aria-selected', String(isActive));
        t.tabIndex = isActive ? 0 : -1;
      }

      for (const panel of this.panels) {
        panel.hidden = panel.id !== panelId;
      }
    }

    #setupHeadingFit() {
      const sectionEl = this.closest('.bc-spotlight');
      const heading = sectionEl?.querySelector('[data-bc-fit-heading]');
      if (!heading) return;

      const fit = () => {
        heading.style.whiteSpace = 'nowrap';
        heading.style.fontSize = '';
        let size = parseFloat(window.getComputedStyle(heading).fontSize);
        let guard = 40;
        while (heading.scrollWidth > heading.clientWidth && size > 15 && guard > 0) {
          size -= 1;
          guard -= 1;
          heading.style.fontSize = size + 'px';
        }
      };

      fit();
      if (document.fonts?.ready) document.fonts.ready.then(fit);

      const observer = new ResizeObserver(fit);
      observer.observe(sectionEl);
      this.#observers.push(observer);
    }

    #setupScrollButtons(signal) {
      for (const panel of this.panels) {
        const track = panel.querySelector('.bc-spotlight__track');
        const prevButton = panel.querySelector('[data-scroll-prev]');
        const nextButton = panel.querySelector('[data-scroll-next]');
        if (!track) continue;

        const updateButtons = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          const hasOverflow = maxScroll > 4;
          if (prevButton) {
            prevButton.hidden = !hasOverflow;
            prevButton.disabled = track.scrollLeft <= 4;
          }
          if (nextButton) {
            nextButton.hidden = !hasOverflow;
            nextButton.disabled = track.scrollLeft >= maxScroll - 4;
          }
        };

        const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth';

        prevButton?.addEventListener(
          'click',
          () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: scrollBehavior }),
          { signal }
        );

        nextButton?.addEventListener(
          'click',
          () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: scrollBehavior }),
          { signal }
        );

        track.addEventListener('scroll', updateButtons, { passive: true, signal });

        const observer = new ResizeObserver(updateButtons);
        observer.observe(track);
        this.#observers.push(observer);

        updateButtons();
      }
    }
  }

  if (!customElements.get('bc-spotlight-tabs')) {
    customElements.define('bc-spotlight-tabs', BcSpotlightTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-lineup"] && !Shopify.designMode) return;
  try {
    
  class ScentLineupTabs extends HTMLElement {
    #abortController = null;
    #observers = [];

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      for (const tab of this.tabs) {
        tab.addEventListener('click', this.#handleTabClick.bind(this), { signal });
        tab.addEventListener('keydown', this.#handleTabKeydown.bind(this), { signal });
      }

      this.#setupScrollButtons(signal);
      this.#setupHeadingFit();

      if (window.Shopify?.designMode) {
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const panel = this.panels.find(
              (p) => p === event.target || p.contains(event.target)
            );
            if (!panel) return;
            const tab = this.tabs.find(
              (t) => t.getAttribute('aria-controls') === panel.id
            );
            if (tab) this.#activateTab(tab);
          },
          { signal }
        );
      }
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      for (const observer of this.#observers) observer.disconnect();
      this.#observers = [];
    }

    #handleTabClick(event) {
      this.#activateTab(event.currentTarget);
    }

    #handleTabKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let newIndex = null;

      if (event.key === 'ArrowRight') newIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') newIndex = 0;
      if (event.key === 'End') newIndex = this.tabs.length - 1;

      if (newIndex === null) return;

      event.preventDefault();
      const nextTab = this.tabs[newIndex];
      this.#activateTab(nextTab);
      nextTab.focus();
    }

    #activateTab(tab) {
      const panelId = tab.getAttribute('aria-controls');

      for (const t of this.tabs) {
        const isActive = t === tab;
        t.setAttribute('aria-selected', String(isActive));
        t.tabIndex = isActive ? 0 : -1;
      }

      for (const panel of this.panels) {
        panel.hidden = panel.id !== panelId;
      }
    }

    #setupHeadingFit() {
      const sectionEl = this.closest('.scent-lineup');
      const heading = sectionEl?.querySelector('[data-bc-fit-heading]');
      if (!heading) return;

      const fit = () => {
        heading.style.whiteSpace = 'nowrap';
        heading.style.fontSize = '';
        let size = parseFloat(window.getComputedStyle(heading).fontSize);
        let guard = 40;
        while (heading.scrollWidth > heading.clientWidth && size > 15 && guard > 0) {
          size -= 1;
          guard -= 1;
          heading.style.fontSize = size + 'px';
        }
      };

      fit();
      if (document.fonts?.ready) document.fonts.ready.then(fit);

      const observer = new ResizeObserver(fit);
      observer.observe(sectionEl);
      this.#observers.push(observer);
    }

    #setupScrollButtons(signal) {
      for (const panel of this.panels) {
        const track = panel.querySelector('.scent-lineup__track');
        const prevButton = panel.querySelector('[data-scroll-prev]');
        const nextButton = panel.querySelector('[data-scroll-next]');
        if (!track) continue;

        const updateButtons = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          const hasOverflow = maxScroll > 4;
          if (prevButton) {
            prevButton.hidden = !hasOverflow;
            prevButton.disabled = track.scrollLeft <= 4;
          }
          if (nextButton) {
            nextButton.hidden = !hasOverflow;
            nextButton.disabled = track.scrollLeft >= maxScroll - 4;
          }
        };

        const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth';

        prevButton?.addEventListener(
          'click',
          () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: scrollBehavior }),
          { signal }
        );

        nextButton?.addEventListener(
          'click',
          () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: scrollBehavior }),
          { signal }
        );

        track.addEventListener('scroll', updateButtons, { passive: true, signal });

        const observer = new ResizeObserver(updateButtons);
        observer.observe(track);
        this.#observers.push(observer);

        updateButtons();
      }
    }
  }

  if (!customElements.get('scent-lineup-tabs')) {
    customElements.define('scent-lineup-tabs', ScentLineupTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-quiz"] && !Shopify.designMode) return;
  try {
    
  class ScentQuizApp extends HTMLElement {
    #abortController = null;
    #answers = {};
    #observers = [];

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.stages = {
        intro: this.querySelector('[data-quiz-stage="intro"]'),
        questions: this.querySelector('[data-quiz-stage="questions"]'),
        results: this.querySelector('[data-quiz-stage="results"]'),
      };
      this.questionEls = Array.from(this.querySelectorAll('[data-quiz-question]'));
      this.resultEls = Array.from(this.querySelectorAll('[data-quiz-result]'));
      this.progressWrap = this.querySelector('[data-quiz-progress-wrap]');
      this.progressFill = this.querySelector('[data-quiz-progress-fill]');
      this.progressLabel = this.querySelector('[data-quiz-progress-label]');
      this.currentIndex = 0;

      this.querySelector('[data-quiz-start]')?.addEventListener(
        'click',
        () => this.#goToQuestion(0),
        { signal }
      );

      this.querySelector('[data-quiz-restart]')?.addEventListener(
        'click',
        () => this.#restart(),
        { signal }
      );

      for (const questionEl of this.questionEls) {
        const index = Number(questionEl.dataset.questionIndex);
        const isLast = questionEl.dataset.isLast === 'true';

        for (const answerBtn of questionEl.querySelectorAll('[data-quiz-answer]')) {
          answerBtn.addEventListener(
            'click',
            () => this.#selectAnswer(questionEl, answerBtn, index, isLast),
            { signal }
          );
        }

        questionEl
          .querySelector('[data-quiz-back]')
          ?.addEventListener('click', () => this.#goBack(index), { signal });

        questionEl
          .querySelector('[data-quiz-continue]')
          ?.addEventListener('click', () => this.#finish(), { signal });
      }

      if (window.Shopify?.designMode) {
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            if (!this.contains(event.target)) return;
            const questionEl = event.target.closest('[data-quiz-question]');
            if (questionEl) {
              this.#goToQuestion(Number(questionEl.dataset.questionIndex));
              return;
            }
            const resultEl = event.target.closest('[data-quiz-result]');
            if (resultEl) {
              for (const r of this.resultEls) r.hidden = r !== resultEl;
              this.#showStage('results');
            }
          },
          { signal }
        );
      }

      this.#setupHeadingFit();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      for (const observer of this.#observers) observer.disconnect();
      this.#observers = [];
    }

    #showStage(name) {
      for (const key of Object.keys(this.stages)) {
        if (this.stages[key]) this.stages[key].hidden = key !== name;
      }
      if (this.progressWrap) this.progressWrap.hidden = name !== 'questions';
    }

    #goToQuestion(index) {
      this.#showStage('questions');
      for (const el of this.questionEls) {
        const isActive = Number(el.dataset.questionIndex) === index;
        el.hidden = !isActive;
        if (isActive && el.dataset.isLast === 'true') {
          const legal = el.querySelector('[data-quiz-legal]');
          if (legal) legal.hidden = false;
        }
      }
      this.currentIndex = index;
      this.#updateProgress(index);
    }

    #updateProgress(index) {
      const total = this.questionEls.length;
      if (!total) return;
      const pct = ((index + 1) / total) * 100;
      if (this.progressFill) this.progressFill.style.width = pct + '%';
      if (this.progressLabel) {
        const template = this.dataset.progressLabel || 'Question {current} of {total}';
        this.progressLabel.textContent = template
          .replace('{current}', index + 1)
          .replace('{total}', total);
      }
    }

    #selectAnswer(questionEl, answerBtn, index, isLast) {
      for (const btn of questionEl.querySelectorAll('[data-quiz-answer]')) {
        btn.setAttribute('aria-pressed', String(btn === answerBtn));
      }
      this.#answers[index] = answerBtn.dataset.tag || '';

      if (isLast) {
        const continueBtn = questionEl.querySelector('[data-quiz-continue]');
        const legal = questionEl.querySelector('[data-quiz-legal]');
        if (continueBtn) {
          continueBtn.hidden = false;
          continueBtn.disabled = false;
        }
        if (legal) legal.hidden = false;
        return;
      }

      const nextIndex = index + 1;
      const hasNext = this.questionEls.some(
        (el) => Number(el.dataset.questionIndex) === nextIndex
      );
      window.setTimeout(
        () => {
          if (hasNext) this.#goToQuestion(nextIndex);
          else this.#finish();
        },
        220
      );
    }

    #goBack(index) {
      if (index === 0) {
        this.#showStage('intro');
        return;
      }
      this.#goToQuestion(index - 1);
    }

    #finish() {
      const tally = {};
      for (const tag of Object.values(this.#answers)) {
        if (!tag) continue;
        tally[tag] = (tally[tag] || 0) + 1;
      }

      let winningTag = null;
      let winningCount = -1;
      for (const result of this.resultEls) {
        const tag = result.dataset.resultTag;
        const count = tally[tag] || 0;
        if (count > winningCount) {
          winningCount = count;
          winningTag = tag;
        }
      }

      for (const result of this.resultEls) {
        result.hidden = result.dataset.resultTag !== winningTag;
      }

      this.#showStage('results');
      const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
      this.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
    }

    #restart() {
      this.#answers = {};
      for (const questionEl of this.questionEls) {
        for (const btn of questionEl.querySelectorAll('[data-quiz-answer]')) {
          btn.setAttribute('aria-pressed', 'false');
        }
        const continueBtn = questionEl.querySelector('[data-quiz-continue]');
        const legal = questionEl.querySelector('[data-quiz-legal]');
        if (continueBtn) {
          continueBtn.hidden = true;
          continueBtn.disabled = true;
        }
        if (legal) legal.hidden = true;
      }
      this.#showStage('intro');
    }

    #setupHeadingFit() {
      const heading = this.querySelector('[data-bc-fit-heading]');
      if (!heading) return;

      const fit = () => {
        heading.style.whiteSpace = 'nowrap';
        heading.style.fontSize = '';
        let size = parseFloat(window.getComputedStyle(heading).fontSize);
        let guard = 40;
        while (heading.scrollWidth > heading.clientWidth && size > 15 && guard > 0) {
          size -= 1;
          guard -= 1;
          heading.style.fontSize = size + 'px';
        }
      };

      fit();
      if (document.fonts?.ready) document.fonts.ready.then(fit);

      const observer = new ResizeObserver(fit);
      observer.observe(this);
      this.#observers.push(observer);
    }
  }

  if (!customElements.get('scent-quiz-app')) {
    customElements.define('scent-quiz-app', ScentQuizApp);
  }

  } catch(e) { console.error(e); }
})();
})();
